export default function () {
  return [
    { key: 'company' },
    { key: 'email' },
    // Keys must match the backend AffiliateSearchRequest (orgIds / buIds sets),
    // and the options go in `props` — FilterCard ignores `selectProps`.
    { key: 'orgIds', type: 'org', props: { clearable: true, multiple: true } },
    { key: 'buIds', label: 'businessUnit', type: 'bu', props: { clearable: true, multiple: true } }
  ]
}
